
import "./Techstacks.css";
import { FaAngular, FaReact, FaNode, FaBootstrap, FaNpm } from "react-icons/fa";
import {
  SiHtml5,
  SiExpress,
  SiMysql,
  SiTypescript,
  SiSocketdotio,
  SiWebrtc,
  SiSonarqube,
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { SiJavascript, SiPostman } from "react-icons/si";
import { VscGithub } from "react-icons/vsc";

// Each entry doubles as on-page copy: the label is what a visitor reads, the
// hint is the phrase a search engine sees on hover/announce.
const skills = [
  { Icon: FaAngular, label: "Angular", hint: "Angular developer — components, RxJS, Angular Material" },
  { Icon: FaReact, label: "React", hint: "React developer — hooks, component architecture" },
  { Icon: SiTypescript, label: "TypeScript", hint: "TypeScript developer — typed Angular and React codebases" },
  { Icon: SiJavascript, label: "Javascript", hint: "JavaScript developer — ES6+ and DOM APIs" },
  { Icon: SiHtml5, label: "HTML5", hint: "Semantic, accessible HTML5 markup" },
  { Icon: DiCss3, label: "CSS3", hint: "CSS3, responsive layouts and animation" },
  { Icon: FaBootstrap, label: "Bootstrap", hint: "Bootstrap responsive UI" },
  { Icon: FaNode, label: "Node js", hint: "Node.js backend development" },
  { Icon: SiExpress, label: "Express", hint: "Express REST APIs" },
  { Icon: SiMysql, label: "MySQL", hint: "MySQL database design and queries" },
  { Icon: SiSocketdotio, label: "Socket.IO", hint: "Socket.IO real-time chat features" },
  { Icon: SiWebrtc, label: "WebRTC", hint: "WebRTC live video communication" },
  { Icon: SiPostman, label: "Postman", hint: "Postman API testing" },
  { Icon: VscGithub, label: "GitHub", hint: "Git and GitHub version control" },
  { Icon: FaNpm, label: "npm", hint: "npm package management" },
  { Icon: SiSonarqube, label: "SonarQube", hint: "SonarQube code quality analysis" },
];

export const Techstacks = () => {
  return (
    <>
      <div className="section main" data-aos="fade-right">
        <h2 className="section__title different" id="skills-heading">
          Skills — Angular, React &amp; TypeScript
        </h2>
        <ul className="techsection">
          {skills.map(({ Icon, label, hint }) => (
            <li key={label} title={hint}>
              <Icon aria-hidden="true" />
              <span className="tech-name">{label}</span>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
